// get tab containers
const tabContainers = document.querySelectorAll('.js-tab');

// setup tabs
const setupTabs = (tabContainer) => {
    const tabs = Array.from(tabContainer.querySelectorAll(':scope > .js-tab-btns > .js-tab-btn'));
    const items = tabContainer.querySelectorAll(':scope > .js-tab-content');
    const tabBtnContainer = tabContainer.querySelector(':scope > .js-tab-btns');

    // Add drag scroll functionality
    if (tabBtnContainer) {
        let isDown = false;
        let startX;
        let scrollLeft;
        const scrollSpeedMultiplier = 1.5; // Adjust this value to change scroll speed

        tabBtnContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            tabBtnContainer.style.cursor = 'grabbing';
            startX = e.pageX - tabBtnContainer.offsetLeft;
            scrollLeft = tabBtnContainer.scrollLeft;
        });

        tabBtnContainer.addEventListener('mouseleave', () => {
            isDown = false;
            tabBtnContainer.style.cursor = 'grab';
        });

        tabBtnContainer.addEventListener('mouseup', () => {
            isDown = false;
            tabBtnContainer.style.cursor = 'grab';
        });

        tabBtnContainer.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - tabBtnContainer.offsetLeft;
            const walk = (x - startX) * scrollSpeedMultiplier; // Multiply the scroll distance
            tabBtnContainer.scrollLeft = scrollLeft - walk;
        });

        // Set initial cursor style
        tabBtnContainer.style.cursor = 'grab';
    }

    // Setup nested tabs
    items.forEach((item) => {
        const nestedTabs = item.querySelector('[role="tablist"]');
        if (nestedTabs) setupTabs(nestedTabs);
    });

    // Get all parent tabs for nested structure
    const getParentTabs = (element) => {
        const parents = [];
        let current = element;

        while (current) {
            if (current.matches('.js-tab-btn[aria-selected="true"]')) {
                parents.unshift(current);
            }
            current = current.parentElement;
        }

        return parents;
    };

    const activateTab = (tab) => {
        const target = tab.getAttribute('aria-controls');
        const content = document.getElementById(target);

        // Only update tabs at the same level
        const siblingTabs = Array.from(tab.parentNode.querySelectorAll(':scope > .js-tab-btn'));

        // Update tab states
        siblingTabs.forEach((btn) => btn.setAttribute('aria-selected', 'false'));
        tab.setAttribute('aria-selected', 'true');

        // Update content states - only at this level
        const siblingContent = Array.from(content.parentNode.querySelectorAll(':scope > .js-tab-content'));
        siblingContent.forEach((item) => item.classList.remove('is-active'));
        content.classList.add('is-active');

        // Update URL hash without scrolling
        const allParentTabs = getParentTabs(tab);
        const hashPath = allParentTabs.map((t) => t.getAttribute('aria-controls')).join('/');
        window.history.replaceState(null, '', `#${hashPath}`);
    };

    // Handle keyboard navigation within the current tab level
    const handleKeydown = (e) => {
        const currentTab = tabs.findIndex((tab) => tab === document.activeElement);
        if (currentTab === -1) return;

        let nextTab;
        switch (e.key) {
            case 'ArrowLeft':
                nextTab = currentTab > 0 ? currentTab - 1 : tabs.length - 1;
                break;
            case 'ArrowRight':
                nextTab = currentTab < tabs.length - 1 ? currentTab + 1 : 0;
                break;
            case 'Home':
                nextTab = 0;
                break;
            case 'End':
                nextTab = tabs.length - 1;
                break;
            default:
                return;
        }

        e.preventDefault();
        tabs[nextTab].focus();
        activateTab(tabs[nextTab]);
    };

    // Add click handlers
    tabs.forEach((tab) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', handleKeydown);
    });

    // Handle trigger buttons
    tabContainer.querySelectorAll(':scope > .js-tab-trigger')?.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            activateTab(tabs[button.dataset.index]);
        });
    });

    // Check URL hash on load
    const hash = window.location.hash.slice(1);
    if (hash) {
        const hashParts = hash.split('/');
        const currentLevelHash = hashParts[hashParts.length - 1];
        const selectedTab = tabs.find((tab) => tab.getAttribute('aria-controls') === currentLevelHash);
        if (selectedTab) activateTab(selectedTab);
    }
};

const init = () => {
    if (tabContainers.length === 0) return;

    tabContainers.forEach((tabContainer) => {
        setupTabs(tabContainer);
    });
};

export default init;
